import { useState, useEffect } from 'react';

export const useAnimatedNumber = (
  target: number,
  durationMs: number = 1000,
  enabled: boolean = true
): number => {
  const [displayValue, setDisplayValue] = useState(enabled ? 0 : target);

  useEffect(() => {
    if (!enabled) {
      setDisplayValue(target);
      return;
    }

    let startTimestamp: number | null = null;
    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / durationMs, 1);

      // Ease-out cubic: f(t) = 1 - (1 - t)^3
      const easeOutCubic = 1 - Math.pow(1 - progress, 3);
      setDisplayValue(Math.round(target * easeOutCubic));

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    const animationId = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationId);
  }, [target, durationMs, enabled]);

  return displayValue;
};